import React from 'react';
import {
  Dialog, DialogContent,
  DialogDescription, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../components/ui/select';

/**
 * Create-a-new-client dialog. Fully controlled by parent state.
 *
 * Replaces the inline ~90-line dialog in admin/Clients.jsx so the parent
 * file stays focused on listing/searching clients.
 */
const CreateClientDialog = ({
  open,
  onOpenChange,
  createForm,
  setCreateForm,
  paymentTermsOptions,
  creating,
  onCreateClient,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Create New Client</DialogTitle>
        <DialogDescription className="sr-only">Create New Client dialog. Use the form below to continue.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <Label>Company Name *</Label>
          <Input
            value={createForm.company_name}
            onChange={(e) => setCreateForm({ ...createForm, company_name: e.target.value })}
            placeholder="Acme Coffee Shop"
          />
        </div>
        <div>
          <Label>Contact Name *</Label>
          <Input
            value={createForm.contact_name}
            onChange={(e) => setCreateForm({ ...createForm, contact_name: e.target.value })}
            placeholder="John Smith"
          />
        </div>
        <div>
          <Label>Email *</Label>
          <Input
            type="email"
            value={createForm.email}
            onChange={(e) => setCreateForm({ ...createForm, email: e.target.value })}
            placeholder="contact@company.com"
          />
        </div>
        <div>
          <Label>Phone</Label>
          <Input
            value={createForm.phone}
            onChange={(e) => setCreateForm({ ...createForm, phone: e.target.value })}
            placeholder="(555) 123-4567"
          />
        </div>
        <div>
          <Label>Initial Delivery Address</Label>
          <Input
            value={createForm.address}
            onChange={(e) => setCreateForm({ ...createForm, address: e.target.value })}
            placeholder="123 Main St, City, State"
          />
          <p className="text-xs text-gray-500 mt-1">
            Added as the client&apos;s first delivery location. More can be added later.
          </p>
        </div>
        <div>
          <Label>Password (for portal login)</Label>
          <Input
            type="password"
            value={createForm.password}
            onChange={(e) => setCreateForm({ ...createForm, password: e.target.value })}
            placeholder="Leave blank if no login needed"
          />
          <p className="text-xs text-gray-500 mt-1">
            If provided, client can log into the wholesale portal
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label>Min Order ($)</Label>
            <Input
              type="number"
              value={createForm.minimum_order_amount}
              onChange={(e) => setCreateForm({ ...createForm, minimum_order_amount: parseFloat(e.target.value) })}
            />
          </div>
          <div>
            <Label>Payment Terms</Label>
            <Select
              value={createForm.payment_terms}
              onValueChange={(v) => setCreateForm({ ...createForm, payment_terms: v })}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {paymentTermsOptions.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
      <div className="flex justify-end gap-2 pt-4">
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onCreateClient} disabled={creating} className="bg-amber-500 hover:bg-amber-600">
          {creating ? 'Creating...' : 'Create Client'}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default CreateClientDialog;
